module.exports = __webpack_public_path__ + "img/about-img9.55f69cc8.png";